<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">{{`${item.fname} ${item.lname}`}}</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
            <div class="d-flex align-items-center mb-5">
                <h3 class="card-title mb-0 text-muted">User Information</h3>                            
            </div>
            <div>
                <div class="row mb-2">
                    <label class="col-sm-3">Name</label>
                    <div class="col-sm-6">
                        <span>{{`${item.fname} ${item.lname}`}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Email</label>
                    <div class="col-sm-6">
                        <span>{{item.email}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Created</label>
                    <div class="col-sm-6">
                        <span>{{item.createdAt | df}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            Tracks Observing
		        </h3>
		    </div>
		    <div>
		        <table class="table table-vcenter table-edge">
		            <thead>
		                <tr>
		                    <th class="w-25">
		                        Name
		                    </th>
		                    <th>
		                        Description
		                    </th>
		                    <th>
	                        	Observing ID
	                        </th>
		                    <th>
		                        Status
		                    </th>
		                    <th>
		                        Added
		                    </th>
		                    <th>
		                    </th>
		                </tr>
		            </thead>
		            <tbody>
		                <tr v-for="observing in item.track_observers">
		                    <td>
		                        <router-link :to="{name: 'track-details', params: {id: observing.track.id}}">
		                        	{{observing.track.name}}
		                        </router-link>
		                    </td>
		                    <td>{{observing.track.description}}</td>
		                    <td>{{observing.id}}</td>
		                    <td>
		                    	<span class="tag tag-success" v-if="observing.isActive">Active</span>
		                    	<span class="tag tag-pink" v-else>Disabled</span>
		                    </td>
		                    <td>{{observing.createdAt | df}}</td>                    
		                </tr>		                                
		            </tbody>
		        </table>
		    </div>
		</div>		
	</div>
</template>

<script type="text/javascript">
	import {HTTP} from '@/components/HTTP.js'
	import DateFormat from '@/components/DateFilter.js'

	export default {
		created: function(){
			this.id = this.$route.params.id;
			this.fetch()
		},
		filters: {
			df: DateFormat
		},
		data: function(){
			return {
				id: "",
				item: {
					track_observers: [{track: {}}]
				}
			}
		},
		methods: {
			fetch: function(){
				HTTP.get('/e/observer/' + this.id)
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.item = res.data.data.observer;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/users/UserDetails.vue